// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zlhm","content":"styles_content__24-xb"};